import { crv, css, cva } from '@/styled-system/css';
import type { SystemStyleObject } from '@/styled-system/types';

const defaultSizeStyles = css.raw({
  blockSize: 'auto',
  borderRadius: 'Modal.Content.default',
});

const sizeVariants = crv('size', {
  xs: {
    ...defaultSizeStyles,
    maxInlineSize: 'Modal.Content.size.xs',
  },
  sm: {
    ...defaultSizeStyles,
    maxInlineSize: 'Modal.Content.size.sm',
  },
  md: {
    ...defaultSizeStyles,
    maxInlineSize: 'Modal.Content.size.md',
  },
  lg: {
    ...defaultSizeStyles,
    maxInlineSize: 'Modal.Content.size.lg',
  },
  xl: {
    ...defaultSizeStyles,
    maxInlineSize: 'Modal.Content.size.xl',
  },
  fullScreen: {
    blockSize: '100%',
    borderRadius: 'Modal.Content.fullscreen',
    maxInlineSize: 'Modal.Content.size.fullScreen',
  },
});

export const modalContentRecipe: {
  (props?: any): string;
  raw: (props?: any) => SystemStyleObject;
} = cva({
  base: {
    'display': 'flex',
    'flexDirection': 'column',
    'backgroundColor': 'Modal.Content.bg',
    'boxShadow': 'Modal.Content',
    'position': 'relative',
    'blockSize': 'auto',
    'inlineSize': '100%',
    'minBlockSize': '0',
    // TODO: use animation tokens when available
    'animation': 'zoom-in 0.2s ease-out',
    'zIndex': 2,

    '&:not(:has([data-c11n-component="Modal.Header"]))': {
      paddingBlockStart: 'Modal.Content.offset',
    },
  },
  variants: {
    scrollDocument: {
      true: {},
      false: {
        maxBlockSize: '100%',
      },
    },
    ...sizeVariants,
  },
});
